import { useState, useEffect } from 'react'
import { Box, Divider, Typography, Modal } from '@material-ui/core'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'
import ApprovePopUp from '../../components/ApprovePopUp'
import FieldStatusText from '../../components/FieldStatusText'
import FilledButton from '../../components/FilledButton'
import PDFViewer from '../../components/PDFViewer'
import RejectedReasonPopUp from '../../components/RejectedReasonPopUp '
import RejectReasonPopUp from '../../components/RejectReasonPopUp'
import SiteStatus from '../../components/SiteStatus'
import GreenTick from '../../svgs/greentick'
import RedCross from '../../svgs/redcross'
import ValidateForm from '../ValidateForm'
import CustomDialog from '../../components/CustomDialog'
import { useStyles } from './styles'
const SiteDetails = (props) => {
  const classes = useStyles()
  const { site, setLoading, getSites } = props
  const sitefieldcount = 11
  const [approve, setApprove] = useState(false)
  const [reject, setReject] = useState(false)
  const [confirmed, setConfirmed] = useState(false)
  const [rejected, setRejected] = useState(false)
  const [unenrolled, setUnenrolled] = useState(false)
  const [showRejectReason, setShowRejectReason] = useState(false)
  const [reviewedRowCount, setReviewedRowCount] = useState(0)
  const [approvedRowCount, setApprovedRowCount] = useState(0)
  const [message, setMessage] = useState()
  const [modal, setModal] = useState(false)
  useEffect(() => {
    setReviewedRowCount(0)
    setApprovedRowCount(0)
    site.status === 'approved' ? setConfirmed(true) : setConfirmed(false)
    site.status === 'rejected' ? setRejected(true) : setRejected(false)
    site.status === 'unenrolled' ? setUnenrolled(true) : setUnenrolled(false)
  }, [site])
  const renderErrorModal = () => {
    return (
      <Box className={classes.modalWrapper}>
        <ErrorOutlineOutlinedIcon
          fontSize="large"
          className={classes.errorIcon}
        />
        <Typography className={classes.errorText}>
          Please reject the application!
        </Typography>
        <br />
        <Typography className={classes.errorText}>{message}</Typography>
      </Box>
    )
  }
  const getFieldStatusText = (reviewedRowCount, sitefieldcount) => {
    if (reviewedRowCount !== 0 && reviewedRowCount < sitefieldcount)
      return `Validation of ${sitefieldcount - reviewedRowCount} ${sitefieldcount - reviewedRowCount == 1 ? 'field' : 'fields'
        } pending`
    else if (reviewedRowCount === 0) return 'All fields validation pending'
    else return 'All Fields Validated'
  }
  return (
    <div className={classes.layout}>
      <Box className={classes.detailsreview}>
        {' '}
        <PDFViewer
          amendment_form_presigned_url={
            site?.amendment_form_key != null
              ? site?.amendment_form_presigned_url
              : null
          }
          agreement_form_presigned_url={
            site?.agreement_form_key != null
              ? site?.agreement_form_presigned_url
              : null
          }
          tandc_form_presigned_url={
            site?.tandc_form_key != null
              ? site?.tandc_form_presigned_url
              : null
          }
          approval_form_presigned_url={
            site?.approval_form_key != null
              ? site?.approval_form_presigned_url
              : null
          }
        ></PDFViewer>
        <ValidateForm
          confirmed={confirmed}
          rejected={rejected}
          unenrolled={unenrolled}
          site={site}
          reviewedRowCount={reviewedRowCount}
          setReviewedRowCount={setReviewedRowCount}
          approvedRowCount={approvedRowCount}
          setApprovedRowCount={setApprovedRowCount}
        ></ValidateForm>
      </Box>
      <Divider classes={{ root: classes.dividerroot }}></Divider>
      {confirmed || rejected || unenrolled ? (
        confirmed ? (
          <Box className={classes.statustext}>
            <FieldStatusText statustext="All Fields Validated"></FieldStatusText>
            <Box className={classes.confirmedMessage}>
              <GreenTick></GreenTick>
              <SiteStatus status="The Application has been Approved"></SiteStatus>
            </Box>
          </Box>
        ) : rejected ? (
          <Box className={classes.statustext}>
            <FieldStatusText statustext=""></FieldStatusText>
            <Box className={classes.rejectedMessage} >
              <RedCross></RedCross>
              <SiteStatus status="The Application has been Rejected"></SiteStatus>
              <a
                className={classes.showreasontext}
                onClick={() => setShowRejectReason(true)}
              >
                (Show Reason)
              </a>
            </Box>
          </Box>
        ) : unenrolled ? (
          <Box className={classes.statustext}>
            <FieldStatusText statustext=""></FieldStatusText>
            <Box className={classes.siteStatus}>
              <SiteStatus status="The Application has been Unenrolled"></SiteStatus>

            </Box>
          </Box>) : null
      ) : (
        /*Rejection case for demo purpose*/
        <Box className={classes.statustext}>
          <FieldStatusText
            statustext={getFieldStatusText(reviewedRowCount, sitefieldcount)}
          ></FieldStatusText>
          <Box
            style={{
              // border: '2px solid red',
              width: '350px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <FilledButton
              label="Approve"
              primary={true}
              width="160px"
              disabled={approvedRowCount === sitefieldcount ? false : true}
              onClick={() => {
                setApprove(true)
              }}
            ></FilledButton>
            <FilledButton
              label="Reject"
              primary={false}
              width="160px"
              onClick={() => setReject(true)}
            ></FilledButton>
          </Box>
        </Box>
      )}
      {approve ? (
        <ApprovePopUp
          getSites={getSites}
          setConfirmed={setConfirmed}
          setApprove={setApprove}
          setLoading={setLoading}
          setMessage={setMessage}
          setModal={setModal}
        ></ApprovePopUp>
      ) : null}
      {reject ? (
        <RejectReasonPopUp
          getSites={getSites}
          setRejected={setRejected}
          setReject={setReject}
          setLoading={setLoading}
        ></RejectReasonPopUp>
      ) : null}
      {rejected && showRejectReason ? (
        <RejectedReasonPopUp
          setShowRejectReason={setShowRejectReason}
          reason={site?.reason}
        ></RejectedReasonPopUp>
      ) : null}
      {modal && (
        <CustomDialog
          open={modal}
          fullWidth
          maxWidth="xs"
          title=""
          content={renderErrorModal()}
          handleClose={() => {
            setModal(false)
            setMessage('')
          }}
        />
      )}
    </div>
  )
}
export default SiteDetails
